import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrmDepartmentService {


  url = environment.serverAPI4 + "/api/hrmDepartment";

  constructor(private http: HttpClient) { }

  getAllhrmDesignation(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllhrmDepartmentDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  getAllhrmDepartmentDropDownPrimary(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/primary?type=${type}`);
  }


  gethrmDesignationById(designationId: number): Observable<Object> {
    return this.http.get(`${this.url}/${designationId}`);
  }

  addOrEdithrmDesignation(hrmDesignation: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, hrmDesignation);
  }

  hrmDesignationSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByDepartmentId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }
}
